import { concat, interval, map, Observable, of } from 'rxjs';

export function instantInterval(frequency: number): Observable<number> {
  return concat(of(0), interval(frequency).pipe(map(index => index + 1)));
}
